<template>
  <div class="product-page-v3">
    <!-- 沉浸式Banner -->
    <div class="immersive-banner" data-aos="fade">
      <div class="banner-video-overlay"></div>
      <div class="banner-content" data-aos="fade-up" data-aos-delay="300">
        <h1>善信医养APP — 智能守护，安心托付</h1>
        <p class="banner-subtitle">
          推动传统养老模式向智慧化转型，构建智能化养老服务体系
        </p>
        <el-button type="primary" round class="banner-cta" @click="_goContact"
          >立即咨询方案</el-button
        >
      </div>
    </div>

    <!-- 解决方案 - 横向滑动卡片 -->
    <div class="solutions-carousel-section">
      <div class="section-header" data-aos="fade-up">
        <h2>善信智慧医养服务</h2>
        <p class="section-subtitle">覆盖全场景需求</p>
      </div>

      <div class="carousel-container" data-aos="fade-up" data-aos-delay="200">
        <div class="carousel-track" ref="carouselTrack">
          <div
            v-for="(item, index) in solutions"
            :key="index"
            class="carousel-card"
            :data-aos="'flip-up'"
            :data-aos-delay="index * 100"
          >
            <div class="card-image">
              <img :src="item.imgPlaceholder" alt="" />
            </div>
            <div class="card-content">
              <h3>{{ item.title }}</h3>
              <p>{{ item.description }}</p>
              <!-- <el-button type="text" class="detail-link"
                >查看详情 <i class="el-icon-arrow-right"></i
              ></el-button> -->
            </div>
          </div>
        </div>
        <button class="carousel-nav prev" @click="scrollCarousel(-1)">
          <i class="el-icon-arrow-left"></i>
        </button>
        <button class="carousel-nav next" @click="scrollCarousel(1)">
          <i class="el-icon-arrow-right"></i>
        </button>
      </div>
    </div>

    <!-- 公司优势 - 立体卡片 -->
    <div class="advantages-section">
      <div class="section-header" data-aos="fade-up">
        <h2>专业自研团队，深耕智慧养老领域</h2>
        <p class="section-subtitle">善信医养辐射范围广，提供一站式服务</p>
      </div>

      <div class="advantage-cards">
        <div
          v-for="(item, index) in advantages"
          :key="index"
          class="advantage-card"
          :data-aos="'zoom-in'"
          :data-aos-delay="index * 150"
        >
          <div class="card-inner">
            <div class="card-front">
              <div class="advantage-icon">
                <i :class="item.icon"></i>
              </div>
              <h3>{{ item.title }}</h3>
            </div>
            <div class="card-back">
              <p>{{ item.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 数据展示 -->
    <div class="stats-section" data-aos="fade">
      <div class="stats-container">
        <div
          v-for="(stat, index) in stats"
          :key="index"
          class="stat-item"
          data-aos="fade-up"
          :data-aos-delay="index * 100"
        >
          <div class="stat-value" :data-target="stat.value">
            {{ stat.value }}
          </div>
          <div class="stat-label">{{ stat.label }}</div>
        </div>
      </div>
    </div>

    <!-- 底部CTA - 浮动卡片 -->
    <div
      class="floating-cta"
      data-aos="fade-up"
      data-aos-anchor-placement="top-bottom"
    >
      <div class="cta-card">
        <div class="cta-content">
          <h2>开启智慧养老新时代</h2>
          <p>立即体验善信医养专业解决方案</p>
        </div>
        <el-button type="primary" round class="cta-button" @click="_goContact"
          >免费获取方案</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import "aos/dist/aos.css";
import AOS from "aos";

export default {
  name: "ProductPageV3",
  data() {
    return {
      solutions: [
        {
          title: "客户端",
          description:
            "善信医养用户端APP整合医疗、养老等多元化服务，为用户提供一站式便捷体验。",
          imgPlaceholder: "https://upload.shanxinyy.com/homepage/khd.jpg",
        },
        {
          title: "上门服务",
          description:
            "全天候响应，快速解决您的需求。持证上岗，工具齐全，价格透明，让您足不出户享受高效服务。",
          imgPlaceholder: "https://upload.shanxinyy.com/homepage/smfw.jpg",
        },
        {
          title: "老年餐厅",
          description:
            "科学配餐，守护银发健康。专业营养师搭配，食材当日采购，明厨亮灶看得见！",
          imgPlaceholder: "https://upload.shanxinyy.com/homepage/lnct.jpg",
        },
        {
          title: "线上超市",
          description: "严选好货，专业买手把关，足不出户享受高端购物体验！",
          imgPlaceholder: "https://upload.shanxinyy.com/homepage/xscs.png",
        },
        {
          title: "养老院",
          description: "适老化房间配备紧急呼叫系统，防滑无障碍设计",
          imgPlaceholder: "https://upload.shanxinyy.com/homepage/yly.png",
        },
        {
          title: "智能AI",
          description: "AI分析体检报告，预警潜在风险",
          imgPlaceholder: "https://upload.shanxinyy.com/homepage/ai.png",
        },
        {
          title: "社交圈子",
          description: "退休不孤单，这里有一群志同道合的老伙伴",
          imgPlaceholder: "https://upload.shanxinyy.com/homepage/sjqz.png",
        },
        {
          title: "健康档案",
          description: "在线查看健康检测一体机检测数据和心电图",
          imgPlaceholder: "https://upload.shanxinyy.com/homepage/jkda.jpg",
        },
        {
          title: "智能手表",
          description: "可随时查看善信A8智能手表检测身体健康数据",
          imgPlaceholder: "https://upload.shanxinyy.com/homepage/znsb.jpg",
        },
        {
          title: "旅游拼团",
          description: "慢游不累，专业导游陪同，子女更放心！",
          imgPlaceholder: "https://upload.shanxinyy.com/homepage/lypt.png",
        },
        {
          title: "商家端",
          description: "入驻善信医养平台，轻松拓客，业绩翻倍！",
          imgPlaceholder: "https://upload.shanxinyy.com/homepage/sjd.jpg",
        },
      ],
      advantages: [
        {
          icon: "el-icon-medal",
          title: "10年行业深耕",
          description: "自2015年成立以来，专注智慧养老领域研发与创新",
        },
        {
          icon: "el-icon-cpu",
          title: "自主研发系统",
          description: "拥有2项专利技术,5项软件著作权，系统安全稳定可靠",
        },
        {
          icon: "el-icon-user-solid",
          title: "专业服务团队",
          description: "200+技术专家与养老顾问，提供本地化服务支持",
        },
        {
          icon: "el-icon-office-building",
          title: "一站式养老服务",
          description: "整合当地10+养老服务机构，提供全方位服务",
        },
      ],
      stats: [
        { value: 10, label: "年行业经验" },
        { value: 2, label: "项专利技术" },
        { value: 200, label: "专业团队成员" },
        { value: 10, label: "服务养老机构" },
      ],
    };
  },
  mounted() {
    // 初始化动画库
    AOS.init({
      duration: 800,
      easing: "ease-out-cubic",
      once: true,
      offset: 120,
    });

    // 设置Element主题色
    document.documentElement.style.setProperty("--el-color-primary", "#f97d01");
    document.documentElement.style.setProperty(
      "--el-color-primary-light-3",
      "#ff9d3f"
    );

    // 初始化数字动画
    this.animateStats();
  },
  methods: {
    scrollCarousel(direction) {
      const track = this.$refs.carouselTrack;
      const cardWidth = track.querySelector(".carousel-card").offsetWidth + 30; // 包含margin
      track.scrollBy({ left: direction * cardWidth * 2, behavior: "smooth" });
    },
    animateStats() {
      const statElements = document.querySelectorAll(".stat-value");

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const target = +entry.target.getAttribute("data-target");
              const duration = 2000;
              const start = 0;
              const increment = target / (duration / 16);
              let current = start;

              const timer = setInterval(() => {
                current += increment;
                if (current >= target) {
                  clearInterval(timer);
                  current = target;
                }
                entry.target.textContent =
                  Math.floor(current) + (target > 50 ? "+" : "");
              }, 16);

              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.5 }
      );

      statElements.forEach((el) => observer.observe(el));
    },
  },
};
</script>

<style lang="scss">
/* 全局主题色 */
$primary-color: #f97d01;
$primary-light: lighten($primary-color, 35%);
$primary-dark: darken($primary-color, 10%);

.product-page-v3 {
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  color: #333;
  line-height: 1.6;
  overflow-x: hidden;

  /* 沉浸式Banner */
  .immersive-banner {
    height: 80vh;
    min-height: 600px;
    background: url("https://via.placeholder.com/1920x1080?text=善信医养智慧养老")
      center/cover no-repeat;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

    .banner-video-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        to right,
        rgba($primary-dark, 0.7),
        rgba($primary-color, 0.5)
      );
    }

    .banner-content {
      position: relative;
      z-index: 2;
      max-width: 900px;
      padding: 0 20px;
      color: #fff;

      h1 {
        font-size: 48px;
        font-weight: 600;
        margin-bottom: 20px;
        line-height: 1.2;
        text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
      }

      .banner-subtitle {
        font-size: 22px;
        margin-bottom: 40px;
        opacity: 0.9;
      }
    }

    .banner-cta {
      padding: 14px 40px;
      font-size: 18px;
      background-color: $primary-color;
      border: none;
      font-weight: 500;
      transition: all 0.4s cubic-bezier(0.68, -0.55, 0.27, 1.55);

      &:hover {
        background-color: $primary-dark;
        transform: translateY(-5px) scale(1.05);
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
      }
    }
  }

  /* 通用区块标题样式 */
  .section-header {
    text-align: center;
    margin: 100px 0 60px;

    h2 {
      font-size: 36px;
      font-weight: 600;
      margin-bottom: 15px;
      color: #333;
      position: relative;
      display: inline-block;

      &::after {
        content: "";
        position: absolute;
        bottom: -15px;
        left: 50%;
        transform: translateX(-50%);
        width: 60px;
        height: 4px;
        background: $primary-color;
        border-radius: 2px;
      }
    }

    .section-subtitle {
      font-size: 18px;
      color: #666;
      margin-top: 25px;
    }
  }

  /* 解决方案轮播 */
  .solutions-carousel-section {
    padding: 60px 0;
    background: #f9f9f9;
  }

  .carousel-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;

    .carousel-track {
      display: flex;
      gap: 30px;
      padding: 20px 0;
      overflow-x: auto;
      scroll-snap-type: x mandatory;
      scroll-behavior: smooth;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    .carousel-card {
      flex: 0 0 calc(33.333% - 20px);
      min-width: 300px;
      scroll-snap-align: start;
      background: #fff;
      border-radius: 12px;
      overflow: hidden;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
      transition: all 0.4s;

      &:hover {
        transform: translateY(-10px);
        box-shadow: 0 15px 40px rgba(0, 0, 0, 0.12);

        .card-image img {
          transform: scale(1.1);
        }

        .detail-link i {
          transform: translateX(5px);
        }
      }

      .card-image {
        height: 200px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.6s;
        }
      }

      .card-content {
        padding: 25px;

        h3 {
          font-size: 20px;
          margin-bottom: 15px;
          color: #333;
        }

        p {
          font-size: 15px;
          color: #666;
          margin-bottom: 20px;
          line-height: 1.6;
        }
      }

      .detail-link {
        color: $primary-color;
        padding: 0;
        font-weight: 500;

        i {
          margin-left: 5px;
          transition: transform 0.3s;
        }
      }
    }

    .carousel-nav {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 50px;
      height: 50px;
      border-radius: 50%;
      background: #fff;
      border: none;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 2;
      transition: all 0.3s;

      &:hover {
        background: $primary-color;
        color: #fff;
      }

      &.prev {
        left: 0;
      }

      &.next {
        right: 0;
      }

      i {
        font-size: 20px;
        font-weight: bold;
      }
    }
  }

  /* 立体优势卡片 */
  .advantage-cards {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 30px;
  }

  .advantage-card {
    perspective: 1000px;
    height: 200px;

    .card-inner {
      position: relative;
      width: 100%;
      height: 100%;
      transition: transform 0.8s;
      transform-style: preserve-3d;
    }

    &:hover .card-inner {
      transform: rotateY(180deg);
    }

    .card-front,
    .card-back {
      position: absolute;
      width: 100%;
      height: 100%;
      backface-visibility: hidden;
      border-radius: 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 30px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    }

    .card-front {
      background: #fff;

      .advantage-icon {
        width: 70px;
        height: 70px;
        margin-bottom: 20px;
        background: $primary-light;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          font-size: 32px;
          color: $primary-color;
        }
      }

      h3 {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        text-align: center;
      }
    }

    .card-back {
      background: $primary-color;
      color: #fff;
      transform: rotateY(180deg);

      p {
        font-size: 15px;
        line-height: 1.6;
        text-align: center;
      }
    }
  }

  /* 数据统计 */
  .stats-section {
    padding: 100px 0;
    background: linear-gradient(135deg, $primary-color, $primary-dark);
    color: #fff;
    margin-top: 80px;
  }

  .stats-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 30px;
    text-align: center;
  }

  .stat-item {
    .stat-value {
      font-size: 60px;
      font-weight: 700;
      margin-bottom: 10px;
      line-height: 1;
    }

    .stat-label {
      font-size: 18px;
      opacity: 0.9;
    }
  }

  /* 浮动CTA */
  .floating-cta {
    max-width: 1200px;
    margin: -50px auto 100px;
    padding: 0 20px;
    position: relative;
    z-index: 2;

    .cta-card {
      background: #fff;
      border-radius: 12px;
      padding: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);

      h2 {
        font-size: 28px;
        font-weight: 600;
        margin-bottom: 10px;
        color: #333;
      }

      p {
        font-size: 16px;
        color: #666;
      }
    }

    .cta-button {
      padding: 14px 40px;
      font-size: 18px;
      background-color: $primary-color;
      border: none;
      font-weight: 500;
      transition: all 0.3s;

      &:hover {
        background-color: $primary-dark;
        transform: translateY(-3px);
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
      }
    }
  }

  /* 响应式调整 */
  @media (max-width: 992px) {
    .immersive-banner {
      height: 600px;

      h1 {
        font-size: 36px !important;
      }

      .banner-subtitle {
        font-size: 18px !important;
      }
    }

    .carousel-card {
      flex: 0 0 calc(50% - 15px) !important;
    }

    .advantage-cards {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (max-width: 768px) {
    .immersive-banner {
      height: 500px;

      h1 {
        font-size: 28px !important;
      }

      .banner-subtitle {
        font-size: 16px !important;
      }
    }

    .section-header h2 {
      font-size: 28px !important;
    }

    .carousel-card {
      flex: 0 0 100% !important;
    }

    .advantage-cards {
      grid-template-columns: 1fr;
    }

    .floating-cta .cta-card {
      flex-direction: column;
      text-align: center;

      .cta-button {
        margin-top: 20px;
      }
    }
  }
}
</style>
